import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllWalletReturns = createAsyncThunk(
  "Wallet/FindAllWalletReturn",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/FindAllWalletReturn`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching WalletReturns:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWalletReturn = createAsyncThunk(
  "Wallet/InsertWalletReturn",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/InsertWalletReturn`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WalletReturn:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWalletDetailFromMobileNo = createAsyncThunk(
  "Wallet/GetWalletDetailFromMobileNo",
  async (MobileNo: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Wallet/GetWalletDetailFromMobileNo`,
        { MobileNo }
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WalletDetails:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
